'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.FieldName = void 0;

(function (FieldName) {
  FieldName["FirstName"] = "firstName";
  FieldName["LastName"] = "lastName";
  FieldName["Country"] = "country";
  FieldName["City"] = "city";
  FieldName["PostalCode"] = "zip";
  FieldName["Zone"] = "province";
  FieldName["Address1"] = "address1";
  FieldName["Address2"] = "address2";
  FieldName["Phone"] = "phone";
  FieldName["Company"] = "company";
})(exports.FieldName || (exports.FieldName = {}));

const GRAPHQL_ENDPOINT = 'https://atlas.shopifycloud.com/graphql';
exports.GraphqlOperationName = void 0;

(function (GraphqlOperationName) {
  GraphqlOperationName["Countries"] = "countries";
  GraphqlOperationName["Country"] = "country";
})(exports.GraphqlOperationName || (exports.GraphqlOperationName = {}));

const HEADERS = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
};

exports.GRAPHQL_ENDPOINT = GRAPHQL_ENDPOINT;
exports.HEADERS = HEADERS;
